export default "__VITE_ASSET__f5022d6a__"